import React, { FC } from 'react';
import { ComponentRendering, Placeholder, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import ctaTypes from '../../../../enums/CTA.enums';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import CTA from '../../../@shared/cta';
import { InteractiveImageModel } from '../../models/interactiveImage.model';
import { TInteractiveImageProps } from '../../types/interactiveImage.types';

const InteractiveImageText: FC<TInteractiveImageProps & { isEE: boolean }> = (props) => {
  const model = new InteractiveImageModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);

  return (
    <div className="interactive-image-text-wrapper">
      <div className="interactive-image-text">
        {model.eyebrow && <Text field={model.eyebrow} tag="p" className="interactive-image-text__eyebrow" />}
        {model.title && <Text field={model.title} tag="p" className="interactive-image-text__title" />}
        {model.description && <RichText field={model.description} tag="div" className="interactive-image-text__description rich-text" />}
        <div className="interactive-image-text__link-wrapper">
          {(props.isEE || model.isPrimaryLinkExists) && (
            <CTA
              field={model.primaryLink}
              target={targetLinkdsk(model?.primaryLink, isDesktop)}
              type={ctaTypes.primaryRed}
              extraClassName="interactive-image-text__primary-link"
            />
          )}
          <div className="interactive-image-text__pop-up">
            <Placeholder name={'jss-generic-popup'} rendering={props.rendering as ComponentRendering} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveImageText;
